import { get, map } from 'lodash';

import { GEO_AVAILABILITY } from 'constants/contentful';
import Model from 'models';
import Settings from 'utils/Settings';

const PageSectionUgcCarousel = class extends Model {
  get type() {
    return get(this, ['_data', '_contentType']);
  }

  get internalName() {
    return get(this, ['_data', 'internalName']);
  }

  get backgroundColor() {
    return get(this, ['_data', 'backgroundColor']);
  }

  get heading() {
    return get(this, ['_data', 'heading']);
  }

  get desktopConfiguration() {
    return get(this, ['_data', 'desktopConfiguration']);
  }

  get mobileConfiguration() {
    return get(this, ['_data', 'mobileConfiguration']);
  }
  get salesChannelAvailability() {
    return get(this, ['_data', 'salesChannelAvailabilityV2']);
  }

  get imageAndSubtextList() {
    return map(get(this, ['_data', 'imageAndSubtextList']), imageAndSubtext => ({
      src: get(imageAndSubtext, ['image', 'file', 'url']),
      subtext: get(imageAndSubtext, 'subtext'),
    }));
  }

  get isAvailableInCurrentSalesChannel() {
    const salesChannel = Settings._contentfulSettings?.salesChannel;
    const availability = get(this.salesChannelAvailability, [salesChannel, 'Online Store']);

    const isAfterScheduledDate =
      availability?.value === GEO_AVAILABILITY.LATER && new Date(availability?.date) < new Date();

    if (isAfterScheduledDate || availability?.value === GEO_AVAILABILITY.SHOW) {
      return true;
    } else {
      return false;
    }
  }
};

export default PageSectionUgcCarousel;
